export default "__VITE_ASSET__CjFfVsmK__"